import React, {Component} from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

class Screen extends Component	
	render: ()->
		<Wrapper className={classNames(@props.className, {'_active':@props.formState.current is @props._key})}>
			{@props.children}
		</Wrapper>

	next: ()->
		{screenKeys} = @props.formState
		myIndex = screenKeys.findIndex(@props._key)

		if screenKeys[myIndex+1]
			@onNextStep?()
			@props.updateForm {current:screenKeys[myIndex+1]}
			window.scrollTo(0, 0)

	prev: ()->
		{screenKeys} = @props.formState
		myIndex = screenKeys.findIndex(@props._key)

		if screenKeys[myIndex-1]
			@props.updateForm {current:screenKeys[myIndex-1]}
			window.scrollTo(0, 0)


Wrapper = styled.div"""
	padding: 40px 0;
	display: none;

	&._active {
		display: block;
	}
"""


export default Screen